import * as Sounds from '../Sounds';

// Necesario para ejecutar los tests, porque en mocha con jsdom no está definido Audio
const audio = typeof Audio !== 'undefined' ? new Audio(Sounds.ERROR) : undefined;

export function beep() {
	if (audio) {
		audio.pause();
		audio.currentTime = 0;
		void audio?.play();
	}
}